export const FlowSettings = {
    toRequirePassword: {
        key: 'toRequirePassword',
        label: 'Add password or pin to this flow?',
        sub: '',
        tip: null,
        default: false
    },
    passwordRequirement: {
        key: 'passwordRequirement',
        label: 'Password',
        sub: 'Enter in a password',
        tip: null,
        parent: 'toRequirePassword',
        default: null,
        isPrivate: true // ref to db schema FlowSettings isPrivate
    },
    showSidebar: {
        key: 'showSidebar',
        label: 'Show sidebar during flow',
        sub: `Enduser's experience for this section`,
        tip: null,
        default: true
    },
    showControls: {
        key: 'showControls',
        label: 'Allow user to view controls of section experience',
        sub: '',
        tip: `Enduser's experience for this section`,
        default: false
    },
    navigateFreely: {
        key: 'navigateFreely',
        label: 'Allow User To Navigate Freely On The Sidebar',
        sub: '',
        tip: null,
        default: false
    },
    toRequireAuth: {
        key: 'toRequireAuth',
        label: 'Require user sign-in',
        sub: '',
        tip: 'This option requires the user to create an account and sign-in in order to complete flow',
        default: true
    }
    // toEditAnswersAfterCompletion: {
    //   key: 'toEditAnswersAfterCompletion',
    //   label: 'Allow user to edit answers after completing flow',
    //   sub: '',
    //   default: false
    // }
};
export const SectionSettings = {};
//# sourceMappingURL=flow-settings.js.map
